import React, {Component} from "react";
import {Alert, Badge, Button, Table} from "react-bootstrap";
import {AppContext} from "../../AppContext";
import axios from "axios";

/**
 * Przypomnienia handlowe kontrahenta - stan bieżących cykli oraz historia odpowiedzi
 * udzielonych przez serwisantów przy zamykaniu protokołów.
 * Materiał wewnętrzny, wyłącznie do odczytu.
 */
class CustomerReminders extends Component {

    static contextType = AppContext;

    state = {
        state: [],
        answers: [],
        isLoading: true,
        errorMessage: ''
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.customerId !== this.props.customerId) {
            this.loadData();
        }
    }

    loadData = () => {
        if (!this.props.customerId) {
            this.setState({isLoading: false});
            return;
        }
        const config = {
            headers: {"X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json"},
            withCredentials: true
        };
        Promise.all([
            axios.get(`${this.context.hostname}/api/reminder/state/${this.props.customerId}`, config),
            axios.get(`${this.context.hostname}/api/reminder/byCustomer/${this.props.customerId}`, config)
        ]).then(([stateRes, answersRes]) => {
            this.setState({
                state: stateRes.data,
                answers: answersRes.data,
                isLoading: false,
                errorMessage: ''
            });
        }).catch((error) => {
            console.log({error});
            this.setState({isLoading: false, errorMessage: 'Nie udało się pobrać przypomnień.'});
        });
    }

    handleResolve = (answerId) => {
        axios.post(`${this.context.hostname}/api/reminder/resolve/${answerId}`, {}, {
            headers: {"X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json"},
            withCredentials: true
        }).then(() => {
            this.loadData();
        }).catch((error) => {
            console.log({error});
            const status = error.response && error.response.status;
            const serverMessage = error.response && error.response.data && error.response.data.message;
            this.setState({
                errorMessage: (status === 409 || status === 403) && serverMessage
                    ? serverMessage
                    : 'Nie udało się oznaczyć przypomnienia jako wykonane.'
            });
        });
    }

    renderOpen = (item) => {
        if (!item.openAnswerId) return '—';
        return (
            <div>
                <div>NIE z {item.openAnswerDate}{item.openAnswerReason ? ` (${item.openAnswerReason})` : ''}</div>
                {item.verifyByInfoCard &&
                    <div style={{fontSize: 11, fontStyle: 'italic'}}>domknie się automatycznie po wypełnieniu karty informacyjnej</div>}
                {!item.verifyByInfoCard && item.canResolveOpenAnswer &&
                    <Button variant="outline-dark" size="sm" onClick={() => this.handleResolve(item.openAnswerId)}>
                        Oznacz jako wykonane
                    </Button>}
                {/* Oznaczyć jako wykonane może wyłącznie autor odpowiedzi - dla pozostałych API zwraca 403,
                    więc zamiast przycisku pokazujemy informację, kto ma to zrobić */}
                {!item.verifyByInfoCard && !item.canResolveOpenAnswer &&
                    <div style={{fontSize: 11, fontStyle: 'italic'}}>
                        oznaczyć jako wykonane może tylko serwisant, który udzielił odpowiedzi
                    </div>}
            </div>
        );
    }

    renderAnswer = (answer) => {
        if (answer.answer === 'TAK' && answer.verified === false) {
            return (
                <span>
                    <Badge bg="danger">TAK — niepotwierdzone</Badge>{' '}
                    <span style={{fontSize: 11}}>{answer.verificationNote}</span>
                </span>
            );
        }
        if (answer.answer === 'TAK') {
            return (
                <span>
                    <Badge bg="success">TAK</Badge>
                    {answer.verified === true && <span style={{fontSize: 11}}> {answer.verificationNote}</span>}
                </span>
            );
        }
        if (answer.resolved) {
            return (
                <span>
                    <Badge bg="success">TAK</Badge>{' '}
                    <span style={{fontSize: 11}}>
                        (początkowo NIE → wykonano {answer.resolvedAt}
                        {answer.resolvedByName ? `, ${answer.resolvedByName}` : ''}
                        {answer.resolutionSource === 'INFO_CARD' ? ', karta informacyjna' : ''})
                    </span>
                </span>
            );
        }
        //"do zrobienia" tylko gdy po tej odpowiedzi nie ma nowszego potwierdzenia
        return <span><Badge bg="danger">NIE</Badge>{answer.requiresAction &&
            <span style={{fontSize: 11}}> do zrobienia</span>}</span>;
    }

    renderSource = (source, baseDate) => {
        if (source === 'KARTA_INFORMACYJNA') return `karta informacyjna z ${baseDate}`;
        if (source === 'ODPOWIEDZ') return `potwierdzenie z ${baseDate}`;
        return 'brak danych';
    }

    render() {
        return (
            <div style={{padding: '10px'}}>
                <Alert variant='warning' style={{padding: '5px 10px', fontSize: 13}}>
                    <b>Materiał poufny</b> — przypomnienia pojawiają się serwisantom po podpisaniu protokołu.
                </Alert>

                {this.state.errorMessage !== '' &&
                    <Alert variant='danger' style={{padding: '5px 10px'}}>{this.state.errorMessage}</Alert>
                }
                {this.state.isLoading && <div>Wczytywanie...</div>}

                {!this.state.isLoading &&
                    <>
                        <h6>Stan przypomnień</h6>
                        <Table striped bordered hover size="sm" style={{fontSize: 13}}>
                            <thead>
                            <tr>
                                <th>Przypomnienie</th>
                                <th>Cykl</th>
                                <th>Status</th>
                                <th>Podstawa</th>
                                <th>Następne</th>
                                <th>Otwarte NIE</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.state.map(item =>
                                <tr key={item.reminderTypeId}>
                                    <td>{item.question}</td>
                                    <td>{item.periodMonths} mies.</td>
                                    <td>
                                        {item.due
                                            ? <Badge bg="danger">do zrobienia</Badge>
                                            : <Badge bg="success">aktualne</Badge>}
                                    </td>
                                    <td>{this.renderSource(item.baseSource, item.baseDate)}</td>
                                    <td>{item.nextDueDate ? item.nextDueDate : '—'}</td>
                                    <td>{this.renderOpen(item)}</td>
                                </tr>
                            )}
                            {this.state.state.length === 0 &&
                                <tr>
                                    <td colSpan="6" style={{fontStyle: 'italic'}}>Brak aktywnych przypomnień.</td>
                                </tr>
                            }
                            </tbody>
                        </Table>

                        <h6 style={{marginTop: 15}}>Historia odpowiedzi</h6>
                        {this.state.answers.length === 0 &&
                            <div style={{fontStyle: 'italic'}}>Brak odpowiedzi.</div>
                        }
                        {this.state.answers.length > 0 &&
                            <Table striped bordered hover size="sm" style={{fontSize: 13}}>
                                <thead>
                                <tr>
                                    <th>Data</th>
                                    <th>Przypomnienie</th>
                                    <th>Odpowiedź</th>
                                    <th>Powód</th>
                                    <th>Serwisant</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.answers.map(answer =>
                                    <tr key={answer.id}>
                                        <td>{answer.date}</td>
                                        <td>{answer.question}</td>
                                        <td>{this.renderAnswer(answer)}</td>
                                        <td>{answer.reason}</td>
                                        <td>{answer.authorName}</td>
                                    </tr>
                                )}
                                </tbody>
                            </Table>
                        }
                    </>
                }
            </div>
        );
    }
}

export default CustomerReminders;
